export function createCorrelationId(): string {
    if (typeof globalThis.crypto?.randomUUID === "function") {
        return globalThis.crypto.randomUUID();
    }

    return `commerce-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
